import { ControlFacet } from '../models/controls/ControlFacet';

export interface IItemHoverCardProps {
  itemKey: string | undefined;
}

export const itemHoverCardControl: ControlFacet<{
  itemKey: string | undefined;
}, {
    hoverCard: React.ComponentType<IItemHoverCardProps>;
    isAvailable: boolean;
  }> = new ControlFacet('itemHoverCardControl');
